module.exports = __webpack_public_path__ + "static/media/logo.44051220.svg";